import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AgentLayout } from '../../components/AgentLayout';
import api from '../../api';

function Toast({ msg, show }) {
  return <div className={`au-toast ${show ? 'show' : ''}`}>{msg}</div>;
}

export default function AgentProfile() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('au_user') || '{}');
  const initials = user.name?.split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2) || 'AU';
  const [form, setForm] = useState({ currentPin: '', newPin: '', confirmPin: '' });
  const [error, setError] = useState('');
  const [toast, setToast] = useState({ show: false, msg: '' });
  const [loading, setLoading] = useState(false);

  const showToast = (msg) => {
    setToast({ show: true, msg });
    setTimeout(() => setToast({ show: false, msg: '' }), 2500);
  };

  const handleChangePIN = async (e) => {
    e.preventDefault();
    setError('');
    if (form.newPin !== form.confirmPin) { setError('New PINs do not match.'); return; }
    if (!/^\d{4,6}$/.test(form.newPin)) { setError('PIN must be 4–6 digits.'); return; }
    setLoading(true);
    try {
      await api.patch('/auth/change-pin', { currentPin: form.currentPin, newPin: form.newPin });
      setForm({ currentPin: '', newPin: '', confirmPin: '' });
      showToast('PIN changed successfully');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to change PIN.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('au_token');
    localStorage.removeItem('au_user');
    navigate('/login');
  };

  return (
    <AgentLayout>
      <div className="au-page">
        <div style={{ paddingTop: '20px' }}>
          {/* Profile Header */}
          <div className="card fu" style={{ textAlign: 'center', padding: '24px 16px', marginBottom: '16px' }} data-testid="profile-header">
            <div style={{
              width: 64, height: 64, borderRadius: '50%', background: 'var(--navy)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontFamily: 'var(--fh)', fontWeight: 800, fontSize: '22px', color: 'white',
              margin: '0 auto 12px'
            }}>{initials}</div>
            <div style={{ fontFamily: 'var(--fh)', fontSize: '18px', fontWeight: 700, color: 'var(--navy)' }}>{user.name}</div>
            <div style={{ fontSize: '12px', color: 'var(--g3)', marginTop: '3px' }}>{user.employeeId} · Field Agent</div>
            <button
              type="button"
              onClick={() => navigate('/my-performance')}
              data-testid="profile-my-performance-btn"
              style={{
                marginTop: 14,
                display: 'inline-flex', alignItems: 'center', gap: 6,
                background: 'var(--navy)', color: '#fff', border: 'none',
                borderRadius: 999, padding: '8px 14px', fontSize: 12, fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              View my activity & collections →
            </button>
          </div>

          {/* Change PIN */}
          <div className="card fu-1" style={{ marginBottom: '16px' }}>
            <div style={{ fontFamily: 'var(--fh)', fontSize: '15px', fontWeight: 700, color: 'var(--navy)', marginBottom: '14px' }}>
              Change Your PIN
            </div>
            {error && <div className="error-msg" data-testid="profile-error">{error}</div>}
            <form onSubmit={handleChangePIN}>
              <div className="fg">
                <label className="fl">Current PIN</label>
                <input className="fi" type="password" placeholder="Enter current PIN"
                  value={form.currentPin} onChange={e => setForm(p => ({ ...p, currentPin: e.target.value }))}
                  inputMode="numeric" maxLength={6} required data-testid="current-pin" />
              </div>
              <div className="fg">
                <label className="fl">New PIN</label>
                <input className="fi" type="password" placeholder="4–6 digit PIN"
                  value={form.newPin} onChange={e => setForm(p => ({ ...p, newPin: e.target.value }))}
                  inputMode="numeric" maxLength={6} required data-testid="new-pin" />
              </div>
              <div className="fg">
                <label className="fl">Confirm New PIN</label>
                <input className="fi" type="password" placeholder="Re-enter new PIN"
                  value={form.confirmPin} onChange={e => setForm(p => ({ ...p, confirmPin: e.target.value }))}
                  inputMode="numeric" maxLength={6} required data-testid="confirm-pin" />
              </div>
              <button className="sub-btn" type="submit" disabled={loading} data-testid="change-pin-btn">
                {loading ? 'Saving…' : 'Change PIN'}
              </button>
            </form>
          </div>

          {/* Logout */}
          <div className="card fu-2">
            <button
              onClick={handleLogout}
              data-testid="logout-btn"
              style={{
                width: '100%', padding: '11px', background: 'none', color: 'var(--red)',
                border: '1.5px solid var(--red)', borderRadius: '8px', fontFamily: 'var(--fb)',
                fontSize: '14px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.12s'
              }}
            >
              Sign Out
            </button>
          </div>
        </div>
        <div style={{ height: '20px' }} />
      </div>
      <Toast msg={toast.msg} show={toast.show} />
    </AgentLayout>
  );
}
